import React from 'react'

import ProviderContainer from '../../provider/containers/ProviderContainer'

class Profile extends React.Component {


    render() {
    	const { user } = this.props

    	return (
            <div className="page-provider">
                <ProviderContainer provider_id={user.provider} />
            </div>
        )
    }
}


export default Profile



// WEBPACK FOOTER //
// ./src/btoc/components/Profile.js